'use client';

import LocationSearchField from '@/components/LocationSearchField';
import { CategorySelectField } from '@/components/SearchFilters';
import { useState } from 'react';

const Filters = () => {
  const [hideFilters, setHideFilters] = useState(true);
  return (
    <div>
      <button
        className={`${hideFilters ? 'block md:hidden' : 'hidden'} border-midnight-blue-500 w-full rounded-lg border py-2 text-tBase`}
        onClick={() => setHideFilters(!hideFilters)}>
        Filters
      </button>
      <div
        className={`${hideFilters ? 'hidden md:flex' : 'flex'} flex-col gap-5 md:gap-12 lg:flex-row`}>
        <CategorySelectField allLabel="All" label="Property Type" name="propertyType" />
        <CategorySelectField allLabel="All" label="Category" name="propertyCategory" />
        <LocationSearchField handle="addressNear" stateHandle="addressState" />
      </div>
    </div>
  );
};

export default Filters;
